import { CouponQueryDocument } from "@pathwright/graphql-client/src/generated"

export default CouponQueryDocument
